{
	"title": "Review schrijven",
	"loading": "Even kijken welk product het is…",
	"product": {
		"orderedAt": "Besteld op {{date}}",
		"pack": "Pak van {{count}}",
		"noPhoto": "Nog geen foto"
	},
	"intro": "Vertel andere kopers wat je ervan vindt. Alleen de sterren zijn nodig; een kop en een tekst helpen anderen het meest.",
	"form": {
		"stars": {
			"label": "Je sterren",
			"option_one": "{{count}} van 5 sterren",
			"option_other": "{{count}} van 5 sterren",
			"missing": "Kies 1 tot 5 sterren."
		},
		"title": {
			"label": "Kop",
			"placeholder": "Bijvoorbeeld: Past precies op mijn wisser"
		},
		"body": {
			"label": "Je review"
		},
		"firstName": {
			"label": "Voornaam",
			"hint": "Zo staat je naam bij je review. Laat je hem leeg, dan staat er \"Een koper\"."
		},
		"limit": "Hoogstens {{max}} tekens.",
		"submit": "Review versturen",
		"verified": "Je review krijgt het label \"Geverifieerde koper\", omdat hij bij je bestelling hoort."
	},
	"done": {
		"title": "Bedankt voor je review",
		"text": "Je review wordt gecontroleerd voordat hij online komt."
	},
	"link": {
		"invalid": {
			"title": "Deze link werkt niet",
			"text": "De link is niet compleet of klopt niet. Open hem nog een keer vanuit de mail; plak je hem, kopieer dan de hele link."
		},
		"expired": {
			"title": "Deze link is verlopen",
			"text": "Een link om een review te schrijven werkt 60 dagen na de mail. Daarna kun je geen review meer schrijven over deze bestelling."
		},
		"used": {
			"title": "Deze link is al gebruikt",
			"text": "Met deze link is al een review geschreven. Per product per bestelling kun je één review schrijven."
		},
		"alreadyWritten": {
			"title": "Je hebt hier al een review over geschreven",
			"text": "Voor dit product uit deze bestelling staat er al een review. Per product per bestelling kun je één review schrijven."
		},
		"unknown": {
			"title": "We konden je review nu niet openen",
			"text": "Er ging iets mis aan onze kant. Probeer het over een paar minuten opnieuw."
		},
		"retry": "Opnieuw proberen"
	},
	"toHome": "Naar de homepage",
	"optOut": {
		"title": "Afmelden voor reviewverzoeken",
		"text": "Je krijgt dan geen mail meer met de vraag om een review te schrijven. Je bestellingen en de mails daarover blijven gewoon komen.",
		"submit": "Afmelden",
		"missing": "Deze link is niet compleet. Open hem nog een keer vanuit de mail.",
		"invalid": "Deze link klopt niet. Open hem nog een keer vanuit de mail; plak je hem, kopieer dan de hele link.",
		"done": {
			"title": "Je bent afgemeld",
			"text": "Je krijgt geen reviewverzoeken meer van ons."
		}
	}
}
